export default "__VITE_ASSET__BFuUQS5H__"